import PropTypes from 'prop-types';
// @mui
import { Popover } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';

// ----------------------------------------------------------------------

TodoHistoryPopoverComponent.propTypes = {
  sx: PropTypes.object,
  children: PropTypes.node,
};

export default function TodoHistoryPopoverComponent({ children, sx, ...other }) {
  const smUp = useResponsive('up', 'sm');

  const anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
  };

  const transformOrigin = {
    vertical: 'top',
    horizontal: 'right',
  }


  return (
    <Popover
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      PaperProps={{
        sx: {
          mt: 1,
          width: smUp ? '360px' : '100%',
          maxHeight: '450px',
          overflowY: 'scroll',
          overflowX: 'hidden',
          ...sx,
        },
      }}
      {...other}
    >
      {children}
    </Popover>
  );
}
